(function (app) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Tools.AgentCRM",
            {
                url: "/AgentCRM",
                component: "agentcrmsso"          
            });
        }
    ]);

    app.component("agentcrmsso",
    {
        templateUrl: "App/Tools/AgentCRM/AgentCRM.html",
        controller: agentCRMCtrl
    });

   agentCRMCtrl.$inject = ["$mdDialog", "$state"];


   function agentCRMCtrl($mdDialog, $state) {

     
    }

})(window.app); // jshint ignore:line